import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#07090E] text-slate-100 flex items-center justify-center p-6">
      <div className="circa-card p-8 sm:p-10 max-w-md text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-slate-800 border border-white/10 flex items-center justify-center mb-4">
          <XCircle className="w-8 h-8 text-slate-400" />
        </div>
        <h2 className="font-display text-2xl font-extrabold">Checkout cancelled</h2>
        <p className="text-slate-400 text-sm mt-2 leading-relaxed">
          No charges made. You can start your 7-day trial anytime from Settings.
        </p>
        <Link to="/dashboard">
          <Button data-testid="btn-go-dashboard" className="mt-6 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white">
            Back to app <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
